var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRFeedbackDiscF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-feedback-disc-f2",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph-chat-centered-dots"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.346,11.5l-24.692,0c-1.239,0.001 -2.243,1.006 -2.245,2.245l0,17.957c0.002,1.24 1.006,2.244 2.245,2.245l8.343,0l2.078,3.463c0.4,0.658 1.112,1.09 1.925,1.09c0.813,0 1.525,-0.432 1.919,-1.08l0.006,-0.01l2.078,-3.463l8.343,0c1.239,-0.001 2.243,-1.005 2.245,-2.244l-0,-17.958c-0.002,-1.239 -1.006,-2.244 -2.245,-2.245Zm-0,20.203l-8.343,-0c-0.813,0.002 -1.524,0.434 -1.92,1.08l-0.005,0.009l-0,0l-2.078,3.463l-2.078,-3.463c-0.401,-0.655 -1.112,-1.087 -1.924,-1.09l-8.344,0l-0,-17.957l24.692,-0l-0,17.958Zm-14.03,-8.979c0,-0.93 0.754,-1.684 1.684,-1.684c0.93,0 1.683,0.754 1.683,1.684c0,0.93 -0.753,1.683 -1.683,1.683c-0.93,0 -1.684,-0.753 -1.684,-1.683Zm-6.734,-0c0,-0.93 0.754,-1.684 1.684,-1.684c0.93,0 1.683,0.754 1.683,1.684c0,0.93 -0.753,1.683 -1.683,1.683c-0.93,0 -1.684,-0.753 -1.684,-1.683Zm13.469,-0c-0,-0.93 0.753,-1.684 1.683,-1.684c0.93,0 1.684,0.754 1.684,1.684c-0,0.93 -0.754,1.683 -1.684,1.683c-0.93,0 -1.683,-0.753 -1.683,-1.683Z",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRFeedbackDiscF2);
export default __webpack_public_path__ + "static/media/iconR-feedback-disc-f2.651321116b97a31674bd62761a431f84.svg";
export { ForwardRef as ReactComponent };